"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefinitionTable = exports.DefinitionTableDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var icon_1 = require("./icon");
exports.DefinitionTableDefaultProps = {
  items: [],
  justify: 'space-between',
  dividers: true,
  columns: 2
};
// -------- Styles -------->
var TableStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: 0.8em;\n    color: ", ";\n    ", "\n  "], ["\n    font-family: ", ";\n    font-size: 0.8em;\n    color: ", ";\n    ", "\n  "])), theme_1.theme.FONT('sans'), theme_1.theme.COLOR('text'), function (props) {
    return props._dividers && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      ", ";\n    "], ["\n      ", ";\n    "])), theme_1.theme.DOT_BG('h', 'lineMid'));
  }),
  tablet: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: 0.9em;\n  "], ["\n    font-size: 0.9em;\n  "]))),
  desktop: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: 1.0em;\n  "], ["\n    font-size: 1.0em;\n  "])))
});
var TableBodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    width: 100%;\n  "], ["\n    width: 100%;\n  "])))
});
var RowStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    background-position: bottom left;\n    padding: ", " 0;\n\n    ", "\n\n  "], ["\n    background-position: bottom left;\n    padding: ", " 0;\n\n    ", "\n\n  "])), theme_1.theme.UNIT(3), function (props) {
    return props._dividers && (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      ", ";\n    "], ["\n      ", ";\n    "])), theme_1.theme.DOT_BG('h', 'lineMid'));
  }),
  desktop: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props._columns === 2 && (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      margin-right: ", ";\n      width: calc(50% - ", ");\n      :nth-child(2n) {\n        margin-right: 0;\n      }\n    "], ["\n      margin-right: ", ";\n      width: calc(50% - ", ");\n      :nth-child(2n) {\n        margin-right: 0;\n      }\n    "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4));
  })
});
var HeaderCellStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    text-align: left;\n    font-weight: 400;\n    line-height: 1.45em;\n    white-space: nowrap;\n    padding-bottom: ", ";\n    padding-top: ", ";\n    color: ", ";\n    padding-right: ", ";\n    text-transform: uppercase;\n  "], ["\n    text-align: left;\n    font-weight: 400;\n    line-height: 1.45em;\n    white-space: nowrap;\n    padding-bottom: ", ";\n    padding-top: ", ";\n    color: ", ";\n    padding-right: ", ";\n    text-transform: uppercase;\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(2), theme_1.theme.COLOR('text-mid'), theme_1.theme.UNIT(6))
});
var CellStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    width: 90%;\n    line-height: 1.45em;\n    padding-bottom: ", ";\n    padding-top: ", ";\n  "], ["\n    width: 90%;\n    line-height: 1.45em;\n    padding-bottom: ", ";\n    padding-top: ", ";\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(2))
});
var IconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    margin-right: ", ";\n    flex-shrink: 0;\n    margin-top: 2px;\n  "], ["\n    margin-right: ", ";\n    flex-shrink: 0;\n    margin-top: 2px;\n  "])), theme_1.theme.UNIT(2))
});
var HeaderCellContentStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    display: flex;\n    \n  "], ["\n    display: flex;\n    \n  "])))
});
// -------- Components -------->
var My = {
  Table: styled_components_1.default.table(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), TableStyles),
  TableBody: styled_components_1.default.tbody(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), TableBodyStyles),
  Row: styled_components_1.default.tr(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), RowStyles),
  HeaderCell: styled_components_1.default.th(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), HeaderCellStyles),
  HeaderCellContent: styled_components_1.default.span(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), HeaderCellContentStyles),
  Cell: styled_components_1.default.td(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), CellStyles),
  Icon: (0, styled_components_1.default)(icon_1.Icon)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), IconStyles)
};
var DefinitionTable = function (props) {
  var className = props.className,
    items = props.items,
    justify = props.justify,
    dividers = props.dividers,
    columns = props.columns;
  return React.createElement(My.Table, {
    _dividers: dividers,
    className: className
  }, React.createElement(My.TableBody, null, items.map(function (_a) {
    var id = _a.id,
      value = _a.value,
      name = _a.name,
      Icon = _a.icon;
    return React.createElement(My.Row, {
      _columns: columns,
      _dividers: dividers,
      _justify: justify,
      key: id
    }, React.createElement(My.HeaderCell, {
      scope: "row"
    }, React.createElement(My.HeaderCellContent, null, Icon && React.createElement(My.Icon, {
      size: 18
    }, React.createElement(Icon, null)), name, ":")), React.createElement(My.Cell, null, value));
  })));
};
exports.DefinitionTable = DefinitionTable;
exports.DefinitionTable.defaultProps = exports.DefinitionTableDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20;